import { Fragment } from 'react';
import { Row, Col, Form, Card } from 'react-bootstrap';
import { Formik } from 'formik';
import './UploadDocument.scss';
import GenericButton from '../../../Components/GenericButton/GenericButton';
import { useTranslation } from 'react-i18next';
import MultipleFileUpload from '../../../Components/fileupload/MultipleFileUpload';
import FileInfo from '../../../Components/fileupload/FileInfo';
import useUploadDocument from './hooks/useUploadDocument';
import AutoSuggestionSelectComponent from '../common/auto-suggestion-select/Select';
import UploadDocumentsOverlay from './UploadDocumentsOverlay';
import FilterModal from 'src/Admin/components/common/filter-modal/FilterModal';
import DocumentType from './DocumentTypeData/DocumentType';

const SendDocument = ({ userSpecDoc = false }) => {
  const {
    files,
    filesLoader,
    title,
    referenceNumber,
    docType,
    docTypeMeta,
    setDocType,
    comments,
    schema,
    formRef,
    sendDocumentListDefaultValue,
    typeOptionList,
    isOpenOverlayPopup,
    formUploadStatus,
    fileUploadStatus,
    fileProgress,
    serverError,
    setFiles,
    setTitle,
    setReferenceNumber,
    setComments,
    submitData,
    uploadDone,
    retryUploadAllFiles,
    onClickViewButton,
    resetDocType,
    setResetDocType,
    physicianType,
    setPhysicianType,
    selectedDocTypeData,
    setSelectedDocTypeData,
    loadLocation,
    setLoadLocation,
    locationTypeMeta,
    selectedLocationData,
    setSelectedLocationData,
    defaultLocationloader,
    setDefaultLocationloader,
    defaultValueskeletonLoader,
    setDefaultValueSkeletonLoader,
    CustomSearchIcon,
    FormatOptionLabel,
    claimNumberLoading,
    searchedClaimOptions,
    claimNumberText,
    defaultClaimList,
    onSearch,
    checkValidClaim,
  } = useUploadDocument(userSpecDoc);

  const { t } = useTranslation();
  console.log('docType--@', docType);
  console.log('docType--@', docType === undefined);
  console.log('docTypeMeta--@', docTypeMeta);

  return (
    <div>
      <Formik
        validationSchema={schema}
        initialValues={{
          senddocumentfor: sendDocumentListDefaultValue[0]
            ? sendDocumentListDefaultValue[0].fullname
            : '',
          title: title,
          comments: comments,
          type: typeOptionList[0],
          referenceNumber: referenceNumber,
          file: files,
        }}
        onSubmit={async (values) => {
          if (values.type.label === 'Claims') {
            const isValidClaim = await checkValidClaim(values?.referenceNumber);
            if (isValidClaim) submitData(values);
          } else {
            submitData(values);
          }
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          setFieldTouched,
          setFieldValue,
          values,
          touched,
          errors,
        }) => (
          <Form
            className="Upload-Document ml-2 admin-UploadFilesForm-Container"
            onSubmit={handleSubmit}
            ref={formRef}
          >
            {userSpecDoc && (
              <Card className="mb-4">
                <Form.Group className={`form-block`} controlId="UploadFiles">
                  <Row className="mt-4">
                    <Col md={6} lg={6} sm={6}>
                      <Form.Group controlId="type">
                        <Form.Label className="document-labels">
                          {t('member.upload_document.type')}
                          <span className="form-required" aria-hidden={true}>
                            *
                          </span>
                        </Form.Label>
                        <AutoSuggestionSelectComponent
                          options={typeOptionList}
                          name="type"
                          components={{ IndicatorSeparator: () => null }}
                          value={docType}
                          onChange={(e) => {
                            const event = {
                              target: { name: 'type', value: e },
                            };
                            handleChange(event);
                            setDocType(e);
                            setResetDocType(true);
                            setSelectedDocTypeData();
                            setSelectedLocationData();
                            setLoadLocation(false);
                            setDefaultLocationloader(false);
                          }}
                          onBlur={() => {
                            handleBlur({ target: { name: 'type' } });
                          }}
                          fieldTouch={setFieldTouched}
                          isSearchable={false}
                          inputClassName={
                            touched.type && errors.type ? 'invalid-error' : ''
                          }
                          id="type"
                          labelText={'filter dropdown, type'}
                          isRequired={true}
                          isInvalid={touched.type && errors.type}
                          required={true}
                          valid={errors.type ? true : null}
                          describedby="err_type"
                        />
                        <span
                          className="invalid-error"
                          type="invalid"
                          aria-live="polite"
                          id="err_type"
                          role="alert"
                        >
                          {touched.type && errors.type}
                        </span>
                      </Form.Group>
                    </Col>
                  </Row>
                  {!(docType === undefined) &&
                    !['CLAIM'].includes(docType.value) && (
                      <DocumentType
                        docTypeMeta={docTypeMeta}
                        docType={docType}
                        resetDocType={resetDocType}
                        setResetDocType={setResetDocType}
                        physicianType={physicianType}
                        setPhysicianType={setPhysicianType}
                        selectedDocTypeData={selectedDocTypeData}
                        setSelectedDocTypeData={setSelectedDocTypeData}
                        loadLocation={loadLocation}
                        setLoadLocation={setLoadLocation}
                        locationTypeMeta={locationTypeMeta}
                        selectedLocationData={selectedLocationData}
                        setSelectedLocationData={setSelectedLocationData}
                        defaultLocationloader={defaultLocationloader}
                        setDefaultLocationloader={setDefaultLocationloader}
                        defaultValueskeletonLoader={defaultValueskeletonLoader}
                        setDefaultValueSkeletonLoader={
                          setDefaultValueSkeletonLoader
                        }
                      />
                    )}
                </Form.Group>
              </Card>
            )}

            <Card>
              <Form.Group className="form-block" controlId="UploadFiles">
                <Row className="mt-4">
                  {!userSpecDoc && (
                    <Col md={6} lg={6} sm={6}>
                      <Form.Group controlId="senddocumentfor">
                        <Form.Label className="document-labels">
                          Send Documents for
                        </Form.Label>
                        <Form.Control
                          readOnly
                          as="select"
                          name="senddocumentfor"
                          value={
                            sendDocumentListDefaultValue[0]
                              ? sendDocumentListDefaultValue[0].fullname
                              : ''
                          }
                          disabled
                        >
                          <option
                            value={
                              sendDocumentListDefaultValue[0]
                                ? sendDocumentListDefaultValue[0].fullname
                                : ''
                            }
                          >
                            {sendDocumentListDefaultValue[0]
                              ? sendDocumentListDefaultValue[0].fullname
                              : ''}
                          </option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  )}
                  <Col md={6} lg={6} sm={6}>
                    <Form.Group controlId="title">
                      <Form.Label className="document-labels">
                        {t('member.upload_document.title')}
                        <span className="form-required" aria-hidden={true}>
                          *
                        </span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="title"
                        placeholder=""
                        className="title-class"
                        value={values.title ?? ''}
                        spellCheck="off"
                        autoCorrect="off"
                        autoComplete="off"
                        autoFocus={false}
                        onBlur={(e) => {
                          handleBlur(e);
                          const storeTitle = e.currentTarget.value.trim();
                          setFieldValue('title', storeTitle);
                        }}
                        onChange={(e) => {
                          setFieldTouched('title');
                          handleChange(e);
                          setTitle(e.target.value);
                        }}
                        isInvalid={touched.title && errors.title}
                        aria-required={true}
                        aria-invalid={errors.title ? true : null}
                        aria-describedby="err_title"
                      />
                      <Form.Control.Feedback
                        type="invalid"
                        aria-live="polite"
                        id="err_title"
                        role="alert"
                      >
                        <span>{touched.title && errors.title}</span>
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  {!userSpecDoc && (
                    <Col md={6} lg={6} sm={6}>
                      <Form.Group controlId="type">
                        <Form.Label className="document-labels">
                          {t('member.upload_document.type')}
                          <span className="form-required" aria-hidden={true}>
                            *
                          </span>
                        </Form.Label>
                        <AutoSuggestionSelectComponent
                          options={typeOptionList?.filter(
                            (item) =>
                              item?.label === 'Claims' ||
                              item?.label === 'Eligibility',
                          )}
                          name="type"
                          components={{ IndicatorSeparator: () => null }}
                          value={docType}
                          onChange={(e) => {
                            const event = {
                              target: { name: 'type', value: e },
                            };
                            handleChange(event);
                            setDocType(e);
                          }}
                          onBlur={() => {
                            handleBlur({ target: { name: 'type' } });
                          }}
                          fieldTouch={setFieldTouched}
                          isSearchable={false}
                          inputClassName={
                            touched.type && errors.type ? 'invalid-error' : ''
                          }
                          id="type"
                          labelText={'filter dropdown, type'}
                          isRequired={true}
                          isInvalid={touched.type && errors.type}
                          required={true}
                          valid={errors.type ? true : null}
                          describedby="err_type"
                        />
                        <Form.Control.Feedback
                          type="invalid"
                          aria-live="polite"
                          id="err_type"
                          role="alert"
                        >
                          <span>{touched.type && errors.type}</span>
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  )}
                  {docType?.label === 'Claims' && (
                    <Col md={6} lg={6} sm={6}>
                      <Form.Group controlId="referenceNumber">
                        <Form.Label className="document-labels">
                          {t('member.upload_document.reference_number')}
                          <span className="form-required" aria-hidden={true}>
                            *
                          </span>
                        </Form.Label>
                        {userSpecDoc ? (
                          <Form.Control
                            type="text"
                            className="title-class"
                            placeholder=""
                            spellCheck="off"
                            name="referenceNumber"
                            id="referenceNumber"
                            autoCorrect="off"
                            autoComplete="off"
                            autoFocus={false}
                            onBlur={(e) => {
                              handleBlur(e);
                              const storeReferenceNumber =
                                e.currentTarget.value.trim();
                              setFieldValue(
                                'referenceNumber',
                                storeReferenceNumber,
                              );
                            }}
                            onChange={(e) => {
                              handleChange(e);
                              setReferenceNumber(e.target.value);
                            }}
                            value={values.referenceNumber ?? ''}
                            describedby="err_referenceNumber"
                            isInvalid={
                              touched.referenceNumber && errors.referenceNumber
                            }
                          />
                        ) : (
                          <AutoSuggestionSelectComponent
                            placeholder="Example: CLM20230620001"
                            components={{
                              DropdownIndicator: CustomSearchIcon,
                              IndicatorSeparator: () => null,
                              Option: FormatOptionLabel,
                            }}
                            options={
                              claimNumberLoading
                                ? []
                                : claimNumberText
                                ? searchedClaimOptions
                                : defaultClaimList
                            }
                            onInputChange={(e) => onSearch(e)}
                            inputClassName="border-right-0"
                            isLoading={claimNumberLoading}
                            onChange={(e) => {
                              setReferenceNumber(e);
                              const event = {
                                target: {
                                  name: 'referenceNumber',
                                  value: e?.value,
                                },
                              };
                              handleChange(event);
                            }}
                            value={referenceNumber}
                            id="referenceNumber"
                            name="referenceNumber"
                            valid={
                              touched.referenceNumber && errors.referenceNumber
                                ? true
                                : null
                            }
                            noOptionsMessage={() =>
                              claimNumberLoading
                                ? 'Loading...'
                                : 'No Data Found'
                            }
                            describedby="err_referenceNumber"
                            labelText={t(
                              'member.price_comparison.procedure_container.health_procedure_dropdown_labelText',
                            )}
                          />
                        )}

                        <Form.Control.Feedback
                          type="invalid"
                          aria-live="polite"
                          id="err_referenceNumber"
                          role="alert"
                          className="d-block"
                        >
                          <span>
                            {touched.referenceNumber && errors.referenceNumber}
                          </span>
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  )}
                </Row>
              </Form.Group>

              <Row className="w-90 mt-3">
                <Col md={12} lg={12} sm={12}>
                  <MultipleFileUpload
                    className={
                      files.length <= 0 && touched.file && errors.file
                        ? 'errorbackground'
                        : ''
                    }
                    files={files}
                    setFiles={setFiles}
                    name="file"
                    setFieldValue={setFieldValue}
                  />
                  {files && files.length > 0 ? (
                    ''
                  ) : (
                    <span className="sr-only">
                      {touched.file && errors.file}
                    </span>
                  )}
                </Col>
                <Col md={12} lg={6} sm={12}>
                  {files.length > 0 ? (
                    <div
                      className="sr-only"
                      role="heading"
                      aria-level={1}
                      tabIndex={0}
                    ></div>
                  ) : (
                    ''
                  )}
                  <div>
                    {files &&
                      files.map((item, index) => {
                        return (
                          <Fragment key={index}>
                            <FileInfo
                              files={files}
                              setFiles={setFiles}
                              fileDetails={item}
                              filesLoader={false}
                              setFieldValue={setFieldValue}
                              readFileSize={true}
                            />
                          </Fragment>
                        );
                      })}
                  </div>
                </Col>
              </Row>

              <Row className="mt-3 w-90">
                <Col md={12} lg={12} sm={12}>
                  <Form.Group className="form-block" controlId="comments">
                    <Form.Label className="document-labels">
                      {t('member.upload_document.comment')}
                    </Form.Label>
                    <Form.Control
                      rows={4}
                      as="textarea"
                      className="textarea-class-comment"
                      spellCheck="off"
                      autoCorrect="off"
                      autoComplete="off"
                      name="comments"
                      autoFocus={false}
                      onBlur={(e) => {
                        handleBlur(e);
                        const storeComments = e.currentTarget.value.trim();
                        setFieldValue('comments', storeComments);
                      }}
                      onChange={(e) => {
                        setFieldTouched('comments');
                        handleChange(e);
                        setComments(e.target.value);
                      }}
                      value={comments ?? ''}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className=" d-flex justify-content-between align-items-center mt-4 mb-4 button-container">
                <div>
                  <button
                    onClick={onClickViewButton}
                    className="cancel-btn border-0 bg-transparent"
                    role="button"
                    aria-label="Click on cancel to go to documents list page"
                    tabIndex={0}
                  >
                    {t('member.upload_document.cancel')}
                  </button>
                </div>
                <div>
                  <GenericButton
                    type="submit"
                    variant="primary"
                    tabIndex={0}
                    ariaLabel="Click send button to upload document information"
                  >
                    {t('member.upload_document.send')}
                  </GenericButton>
                </div>
              </div>

              <FilterModal
                isVisible={isOpenOverlayPopup}
                titleLabel={'Send Documents'}
                showCancel={true}
                showCancelLabel={'Close'}
                showApply={fileUploadStatus === 'failed' || serverError}
                showApplyLabel={'Retry'}
                showBackButton={false}
                onHide={uploadDone}
                applyFilterHandler={() =>
                  serverError ? submitData(values) : retryUploadAllFiles()
                }
                customClasses="overlayclass"
              >
                <UploadDocumentsOverlay
                  files={files}
                  setFiles={setFiles}
                  filesLoader={filesLoader}
                  setFieldValue={setFieldValue}
                  formUploadStatus={formUploadStatus}
                  fileProgress={fileProgress}
                  fileUploadStatus={fileUploadStatus}
                  serverError={serverError}
                  readFileSize={false}
                />
              </FilterModal>
            </Card>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default SendDocument;
